export const translations = {
  fr: {
    nav_about: 'À propos',
    nav_skills: 'Compétences',
    nav_projects: 'Projets',
    nav_parcours: 'Parcours',
    nav_certifications: 'Certifications',
    nav_experience: 'Expérience',
    nav_cta: 'Parlons de votre projet',
    lang_toggle_aria: 'Switch language / Changer de langue',
    menu_open: 'Ouvrir le menu',
    menu_close: 'Fermer le menu',

    hero_title_line1: 'Du concept au code,',
    hero_title_line2: ' je crée des solutions digitales qui répondent à vos besoins.',
    hero_lead:
      'Vous avez une vision : je lui donne vie. De la conception au lancement, je développe des solutions numériques efficaces, évolutives et pensées pour durer.',
    hero_name: 'TALLA FOSSI Florent Martial',
    hero_role: 'Ingénieur fullstack · UI/UX Designer',
    hero_type_label: 'Je livre',
    hero_type_1: ' des SaaS prêts à scaler',
    hero_type_2: ' des CRM & ERP sur-mesure',
    hero_type_3: ' des apps IA en production',
    hero_type_4: ' des e-commerce qui convertissent',

    home_projects_eyebrow: 'Portfolio',
    home_projects_title: 'Mon album',
    home_projects_title_line1: 'Mon',
    home_projects_title_line2: ' album',
    home_projects_subtitle:
      'Feuilletez mes 17 réalisations — du SaaS à l\'IA, chaque page raconte une histoire.',
    home_projects_cta: 'Voir la page projets',
    home_projects_album_label: 'Parcourez les projets',
    home_projects_album_hint: 'Cliquez · flèches · clavier',
    home_projects_prev_aria: 'Projet précédent',
    home_projects_next_aria: 'Projet suivant',
    home_project_impact: 'Impact',
    home_project_live: 'Voir le site',
    home_projects_view_btn: 'Voir le projet',
    home_project_shot_prev_aria: 'Capture précédente',
    home_project_shot_next_aria: 'Capture suivante',
    home_section_projects_badge: 'Réalisations concrètes',
    home_section_projects_title_line1: 'Mes',
    home_section_projects_title_line2: ' réalisations',
    home_section_projects_subtitle:
      'Des projets menés de bout en bout — SaaS, IA, e-commerce. Sélectionnez une vignette : chaque carte dévoile le défi, la solution et l’impact obtenu.',

    home_section_journey_badge: 'Parcours',
    home_section_journey_title_line1: 'Mon',
    home_section_journey_title_line2: ' parcours',
    home_section_journey_subtitle:
      'Un socle académique solide en génie informatique, renforcé par une pratique continue sur des projets réels.',
    home_journey_view_about: 'À propos',
    home_path_formation_label: 'Formation',
    home_path_experience_label: 'Expériences professionnelles',
    education_path_tag: 'Parcours',

    home_section_experience_badge: 'Parcours professionnel',
    home_section_experience_title_line1: 'Mes',
    home_section_experience_title_line2: ' expériences professionnelles',
    home_section_experience_subtitle:
      'Missions, responsabilités et réalisations qui ont structuré mon expertise fullstack et produit.',
    home_experience_view_all: 'Voir toutes les expériences',
    experience_path_tag: 'Expérience',

    about_badge: 'Profil professionnel',
    about_title: 'À propos de moi',
    about_subtitle:
      'Développeur fullstack orienté produit, je combine expertise technique et attention UX pour créer des expériences web performantes.',
    about_formation_badge: 'Parcours',
    about_formation_title: 'Formation',
    about_formation_subtitle:
      'Un socle académique solide en génie informatique, renforcé par une pratique continue sur des projets réels.',

    skills_badge: 'Expertise technique',
    skills_title: 'Mes Compétences',
    skills_title_line1: 'Mes',
    skills_title_line2: ' Compétences',
    skills_subtitle:
      'Un aperçu structuré de mes compétences techniques, produit et delivery pour des applications web robustes.',
    skills_flip_hint: 'Survoler pour le détail',
    skills_flip_hint_touch: 'Toucher pour le détail',

    certifications_badge: 'Validations officielles',
    certifications_title: 'Mes Certifications',
    certifications_title_line1: 'Mes',
    certifications_title_line2: ' Certifications',
    certifications_subtitle:
      'Faites défiler mes attestations — une certification par slide, avec le document en grand.',
    certifications_filter_label: 'Filtrer par domaine',
    certifications_filter_all: 'Tous',
    certifications_carousel_label: 'Carrousel des certifications',
    certifications_carousel_hint: 'Glisser · flèches · clavier',
    certifications_prev_aria: 'Certification précédente',
    certifications_next_aria: 'Certification suivante',

    projects_badge: 'Portfolio sélectionné',
    projects_title: 'Mes Projets',
    projects_title_line1: 'Mes',
    projects_title_line2: ' Projets',
    projects_subtitle:
      'Une sélection de réalisations fullstack avec un angle produit : contexte métier, choix techniques, impact et exécution.',

    experience_badge: 'Parcours professionnel',
    experience_title: 'Expérience',
    experience_subtitle:
      'Des expériences variées en fullstack, produit digital et delivery, avec un focus constant sur la valeur métier.',
    experience_timeline_badge: 'Timeline',
    experience_timeline_title_line1: 'Timeline',
    experience_timeline_title_line2: ' professionnelle',
    experience_timeline_subtitle:
      'Missions, responsabilités et réalisations ayant structuré mon expertise.',

    contact_badge: 'Contact',
    contact_title: 'Parlons de votre projet',
    contact_title_line1: 'Parlons de',
    contact_title_line2: ' votre projet',
    contact_subtitle:
      'Expliquez votre besoin, votre contexte et vos objectifs. Je vous réponds rapidement avec une proposition claire.',

    contact_form_label: 'Formulaire',
    contact_form_title: 'Envoyez-moi un message',
    contact_form_subtitle: 'Décrivez votre besoin, je vous recontacte avec une proposition claire.',
    contact_name_label: 'Nom complet',
    contact_name_placeholder: 'Votre nom',
    contact_email_label: 'Email',
    contact_email_placeholder: 'votre@email.com',
    contact_phone_label: 'Téléphone',
    contact_phone_optional: 'optionnel',
    contact_phone_placeholder: '+237 6XX XXX XXX',
    contact_subject_label: 'Sujet',
    contact_subject_placeholder: 'Sélectionnez un sujet',
    contact_subject_project: 'Proposition de projet',
    contact_subject_job: "Opportunité d'emploi",
    contact_subject_collab: 'Collaboration',
    contact_subject_other: 'Autre sujet',
    contact_message_label: 'Message',
    contact_message_placeholder: 'Votre message ici…',
    contact_submit: 'Envoyer le message',
    contact_submitting: 'Envoi en cours…',
    contact_success_title: 'Merci pour votre message !',
    contact_success_text: "Je l'ai bien reçu et je vous répondrai dans les plus brefs délais.",
    contact_success_again: 'Envoyer un autre message',
    contact_error_name: 'Veuillez entrer votre nom',
    contact_error_email: 'Veuillez entrer votre email',
    contact_error_email_invalid: 'Veuillez entrer un email valide',
    contact_error_subject: 'Veuillez sélectionner un sujet',
    contact_error_message: 'Veuillez entrer votre message',
    contact_error_send: "Erreur lors de l'envoi de l'email",
    contact_channel_email: 'Email',
    contact_channel_phone: 'Téléphone',
    contact_channel_location: 'Localisation',
    contact_channel_languages: 'Langues',
    contact_response: 'Réponse sous 24 h',
    contact_whatsapp: 'WhatsApp',
    contact_linkedin: 'LinkedIn',
    contact_channels_label: 'Coordonnées',

    foot_tagline:
      "Développeur Fullstack spécialisé dans la création d'applications web modernes, rapides et maintenables.",
    foot_badge: 'Portfolio',
    foot_nav: 'Navigation',
    foot_home: 'Accueil',
    foot_contact: 'Contact',
    foot_cv_title: 'Mon CV',
    foot_cv_text: "Téléchargez mon CV pour plus d'informations sur mon parcours professionnel.",
    foot_cv_btn: 'Télécharger mon CV',
    foot_rights: 'Tous droits réservés.',
    scroll_top_aria: 'Retour en haut de la page',
  },
  en: {
    nav_about: 'About',
    nav_skills: 'Skills',
    nav_projects: 'Projects',
    nav_parcours: 'Journey',
    nav_certifications: 'Certifications',
    nav_experience: 'Experience',
    nav_cta: "Let's talk about your project",
    lang_toggle_aria: 'Switch language / Changer de langue',
    menu_open: 'Open menu',
    menu_close: 'Close menu',

    hero_title_line1: 'From concept to code,',
    hero_title_line2: ' I build digital solutions that meet your needs.',
    hero_lead:
      'You have a vision — I bring it to life. From design to launch, I develop efficient, scalable digital solutions built to last.',
    hero_name: 'TALLA FOSSI Florent Martial',
    hero_role: 'Fullstack Engineer · UI/UX Designer',
    hero_type_label: 'I deliver',
    hero_type_1: ' SaaS ready to scale',
    hero_type_2: ' custom CRM & ERP systems',
    hero_type_3: ' AI apps in production',
    hero_type_4: ' e-commerce that converts',

    home_projects_eyebrow: 'Portfolio',
    home_projects_title: 'My album',
    home_projects_title_line1: 'My',
    home_projects_title_line2: ' album',
    home_projects_subtitle:
      'Browse my 17 projects — from SaaS to AI, each page tells a story.',
    home_projects_cta: 'View projects page',
    home_projects_album_label: 'Browse the projects',
    home_projects_album_hint: 'Click · arrows · keyboard',
    home_projects_prev_aria: 'Previous project',
    home_projects_next_aria: 'Next project',
    home_project_impact: 'Impact',
    home_project_live: 'View site',
    home_projects_view_btn: 'View project',
    home_project_shot_prev_aria: 'Previous screenshot',
    home_project_shot_next_aria: 'Next screenshot',
    home_section_projects_badge: 'Real-world delivery',
    home_section_projects_title_line1: 'My',
    home_section_projects_title_line2: ' achievements',
    home_section_projects_subtitle:
      'End-to-end builds — SaaS, AI, e-commerce. Pick a thumbnail: each card reveals the challenge, the solution and the impact delivered.',

    home_section_journey_badge: 'Journey',
    home_section_journey_title_line1: 'My',
    home_section_journey_title_line2: ' journey',
    home_section_journey_subtitle:
      'A solid academic foundation in computer engineering, strengthened by continuous hands-on project work.',
    home_journey_view_about: 'About',
    home_path_formation_label: 'Education',
    home_path_experience_label: 'Professional experience',
    education_path_tag: 'Journey',

    home_section_experience_badge: 'Professional journey',
    home_section_experience_title_line1: 'My',
    home_section_experience_title_line2: ' professional experiences',
    home_section_experience_subtitle:
      'Roles, responsibilities and achievements that shaped my fullstack and product expertise.',
    home_experience_view_all: 'View all experiences',
    experience_path_tag: 'Experience',

    about_badge: 'Professional profile',
    about_title: 'About me',
    about_subtitle:
      'Product-oriented fullstack developer combining technical expertise and UX focus to create high-performing web experiences.',
    about_formation_badge: 'Journey',
    about_formation_title: 'Education',
    about_formation_subtitle:
      'A solid academic foundation in computer engineering, strengthened by continuous hands-on project work.',

    skills_badge: 'Technical expertise',
    skills_title: 'My Skills',
    skills_title_line1: 'My',
    skills_title_line2: ' Skills',
    skills_subtitle:
      'A structured overview of my technical, product and delivery skills for robust web applications.',
    skills_flip_hint: 'Hover for details',
    skills_flip_hint_touch: 'Tap for details',

    certifications_badge: 'Official credentials',
    certifications_title: 'My Certifications',
    certifications_title_line1: 'My',
    certifications_title_line2: ' Certifications',
    certifications_subtitle:
      'Browse my credentials — one certification per slide, with the document shown large.',
    certifications_filter_label: 'Filter by domain',
    certifications_filter_all: 'All',
    certifications_carousel_label: 'Certifications carousel',
    certifications_carousel_hint: 'Swipe · arrows · keyboard',
    certifications_prev_aria: 'Previous certification',
    certifications_next_aria: 'Next certification',

    projects_badge: 'Selected portfolio',
    projects_title: 'My Projects',
    projects_title_line1: 'My',
    projects_title_line2: ' Projects',
    projects_subtitle:
      'A selection of fullstack work with a product angle: business context, technical choices, impact and execution.',

    experience_badge: 'Professional journey',
    experience_title: 'Experience',
    experience_subtitle:
      'Varied fullstack, digital product and delivery experience with a constant focus on business value.',
    experience_timeline_badge: 'Timeline',
    experience_timeline_title_line1: 'Professional',
    experience_timeline_title_line2: ' timeline',
    experience_timeline_subtitle:
      'Roles, responsibilities and achievements that shaped my expertise.',

    contact_badge: 'Contact',
    contact_title: "Let's talk about your project",
    contact_title_line1: "Let's talk",
    contact_title_line2: ' about your project',
    contact_subtitle:
      'Share your need, context and goals. I reply quickly with a clear proposal.',

    contact_form_label: 'Form',
    contact_form_title: 'Send me a message',
    contact_form_subtitle: 'Describe your need and I will get back to you with a clear proposal.',
    contact_name_label: 'Full name',
    contact_name_placeholder: 'Your name',
    contact_email_label: 'Email',
    contact_email_placeholder: 'you@email.com',
    contact_phone_label: 'Phone',
    contact_phone_optional: 'optional',
    contact_phone_placeholder: '+237 6XX XXX XXX',
    contact_subject_label: 'Subject',
    contact_subject_placeholder: 'Select a subject',
    contact_subject_project: 'Project proposal',
    contact_subject_job: 'Job opportunity',
    contact_subject_collab: 'Collaboration',
    contact_subject_other: 'Other',
    contact_message_label: 'Message',
    contact_message_placeholder: 'Your message here…',
    contact_submit: 'Send message',
    contact_submitting: 'Sending…',
    contact_success_title: 'Thank you for your message!',
    contact_success_text: 'I received it and will get back to you as soon as possible.',
    contact_success_again: 'Send another message',
    contact_error_name: 'Please enter your name',
    contact_error_email: 'Please enter your email',
    contact_error_email_invalid: 'Please enter a valid email',
    contact_error_subject: 'Please select a subject',
    contact_error_message: 'Please enter your message',
    contact_error_send: 'Error sending email',
    contact_channel_email: 'Email',
    contact_channel_phone: 'Phone',
    contact_channel_location: 'Location',
    contact_channel_languages: 'Languages',
    contact_response: 'Reply within 24 h',
    contact_whatsapp: 'WhatsApp',
    contact_linkedin: 'LinkedIn',
    contact_channels_label: 'Contact details',

    foot_tagline:
      'Fullstack developer specialized in building modern, fast and maintainable web applications.',
    foot_badge: 'Portfolio',
    foot_nav: 'Navigation',
    foot_home: 'Home',
    foot_contact: 'Contact',
    foot_cv_title: 'My resume',
    foot_cv_text: 'Download my resume for more details about my professional background.',
    foot_cv_btn: 'Download my resume',
    foot_rights: 'All rights reserved.',
    scroll_top_aria: 'Back to top',
  },
};
